"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppModule = void 0;
const vue_1 = __importDefault(require("vue"));
const vuex_1 = __importDefault(require("vuex"));
const vuex_class_1 = require("vuex-class");
const app_1 = __importDefault(require("./modules/app"));
vue_1.default.use(vuex_1.default);
exports.AppModule = vuex_class_1.namespace('app');
exports.default = new vuex_1.default.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        app: app_1.default
    }
});
